import { useState, useEffect } from "react";
import { db } from "../firebase/firebaseConfig";
import { collection, onSnapshot, query  } from "firebase/firestore";




const useObtenerTiposDeCliente = () => {

    const [ tiposDeClientes, setTiposDeClientes]=useState([]);

    useEffect(()=>{
        const consulta=query(
            collection(db, 'TiposDeClientes')
        )
       
            const unsub = onSnapshot(consulta, (snapshot) => {
                    const dataSnapShot=snapshot.docs.map((stock)=>{
                       
                        return [
                                stock.id,
                                stock.data().nombre,
                              stock.data().descuento
                             
                        ]
                    });
                    setTiposDeClientes(dataSnapShot) ;
            });
          
            
            return unsub;
           
    },[])
    return [tiposDeClientes];
}
 
export default useObtenerTiposDeCliente;